import script from "./MessageUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageUploader.vue?vue&type=script&setup=true&lang=ts"

import "./MessageUploader.vue?vue&type=style&index=0&id=ca175e06&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca175e06"]])

export default __exports__